import React from 'react';
import moment from 'moment';
import { withRouter, Link } from 'react-router-dom';

import { Create, PlayArrow } from '@material-ui/icons';

import './VideoWidget.css';

class VideoWidget extends React.Component {

  askToDelete = video => {
    const canDelete = window.confirm('Are you sure you want to delete this video?');
    if (canDelete) {
      this.props.deleteVideo(video);
    }
  }
  render () {
    const {
      video,
      toggleMenu,
      menuActive,
      passVideoForEditing,
      match: { url }
    } = this.props;
    const videoPath = `${url}/${video.videoId}`;
    return (
      <div
        className="widget-container col-md-3 col-sm-4 col-xs-12">
        <div
          className="video-menu"
          tabIndex={video.videoId}
          onBlur={() => toggleMenu('')}>
          <Create
            fontSize="large"
            onClick={event => {
              event.stopPropagation();
              toggleMenu(`${video.videoId}`);
            }}
          />
          {menuActive && (
            <div className="menu-container">
              <ul className="menu">
                <li onClick={() => passVideoForEditing(video)}>Edit video details</li>
                <li onClick={() => this.askToDelete(video.videoId)}>Delete video</li>
              </ul>
            </div>
          )}
        </div>
        <Link
          to={videoPath}
          className="video-image"
          style={{ backgroundImage: `url(${video.snapshotUrl})` }}>
          <div className="video-play-icon">
            <PlayArrow fontSize="large" />
          </div>
        </Link>
        <div className="video-info">
          <p className="video-desc">{video.title}</p>
          <p className="video-date">{moment(video.dateAdded).format('dddd, MMM DD, YYYY')}</p>
        </div>
      </div>
    );
  }
}

export default withRouter(VideoWidget);